import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { tasksId } from '../../../types/activityTasks';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { RandomQuestion } from '../../../components/common/RandomQuestion';
import { shuffleArray } from '../../../helpers/questionRandom';
import { imagesTheme3 } from '../../../assets/tema3';
import { voicesTypeControl } from '../../../types/audioType';
import { ButtonReturn } from '../../../components/common/ButtonReturn';


const stepGame = [
	{
		id: 0,
		title: "Paso 1",
		text: "Destapa la quesera.",
		img: imagesTheme3.topic1.paso1Quesera
	},
	{
		id: 1,
		title: "Paso 2",
		text: "Retira el destapador.",
		img: imagesTheme3.topic1.paso2Quesera
	},
	{
		id: 3,
		title: "Paso 3",
		text: "Retira el separador.",
		img: imagesTheme3.topic1.paso3Quesera
	},
	{
		id: 4,
		title: "Paso 4",
		text: `Quita las pesas.`,
		img: imagesTheme3.topic1.paso4Quesera
	},
	{
		id: 5,
		title: "Paso 5",
		text: "Revisa que la bolsa de queso no este vacía o caduca.",
		img: imagesTheme3.topic1.paso5Quesera
	},
	{
		id: 6,
		title: "Paso 6",
		text: "Inserta la válvula a la bolsa.",
		img: imagesTheme3.topic1.paso6Quesera
	},
	{
		id: 7,
		title: "Paso 7",
		text: "Introduce la bolsa con su válvula a la máquina.",
		img: imagesTheme3.topic1.paso7Quesera
	},
	{
		id: 8,
		title: "Paso 8",
		text: "Coloca las piezas de la quesera en su lugar.",
		img: imagesTheme3.topic1.paso8Quesera
	},
	{
		id: 9,
		title: "Paso 9",
		text: "Verifica que haya de 8 a 15 paquetes de queso.",
		img: imagesTheme3.topic1.paso9Quesera
	},
];

const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	dialogTwo: 3,
	gameQuestion: 4,
	win: 5,
	fail: 6
};

let pointsWin = 0

export const Theme3SubtopicOneActivityFive = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema3.activities.subtema1], 5);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 3 sub 1 act 5");
			ObserverEmitter.emit(EVENTS.tema3.actOne.initScene, 5);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_1.sub1_act5_a01T3)
	})

	const [numberQuestion, setNumberQuestion] = useState(0);
	const [questionGameOne, setQuestionGameOne] = useState([]);
	const [saveResponsesGameOne, setSaveResponsesGameOne] = useState([]);
	const [responseQuestionGameOne, setResponseQuestionGameOne] = useState([]);


	const checkCorrectsInGameOne = (array = []) => {
		const trueElements = array.filter(element => element === true);
		return trueElements.length >= 3;
	}

	const getRandomQuestionGame = useCallback(() => {
		const newQuestion = shuffleArray(stepGame);
		const questions = newQuestion.slice(0, 5);
		const newResponse = shuffleArray(questions);
		setQuestionGameOne(questions);
		setResponseQuestionGameOne(newResponse);
	}, []);

	useEffect(() => {
		getRandomQuestionGame();
	}, [getRandomQuestionGame]);

	const finishSubactivityOne = (isWin = false) => {
		if (isWin) {
			setUiToShow(steps.win);
		} else {
			setUiToShow(steps.fail);
		}
	};

	const condition = (client) => client.id === questionGameOne[numberQuestion + 1].id;

	const verificationResponse = (selectNumber = -1) => {
		if (selectNumber === -1) {
			return;
		}

		if (numberQuestion + 1 >= questionGameOne.length + 1) {
			const resultadoThreeWin = checkCorrectsInGameOne(saveResponsesGameOne)
			finishSubactivityOne(resultadoThreeWin);
			return;
		}

		//* verificar si es correcto
		const isCorrectResponse = questionGameOne[numberQuestion].id === selectNumber;
		const saveGame = [...saveResponsesGameOne, isCorrectResponse];

		if (isCorrectResponse) {
			pointsWin += 5
		}

		if (numberQuestion + 1 === questionGameOne.length) {
			const resultadoThreeWin = checkCorrectsInGameOne(saveGame)
			finishSubactivityOne(resultadoThreeWin);
			return;
		}

		//* revolver respuestas
		const matchingObject = stepGame.find(condition);
		const nonMatchingObjects = stepGame.filter((client) => !condition(client));
		const shuffleNonMatchingObjects = shuffleArray(nonMatchingObjects);
		const sliceNonMatchingObjects = shuffleNonMatchingObjects.slice(0, 4);
		sliceNonMatchingObjects.push(matchingObject);
		const shuffleNewResponse = shuffleArray(sliceNonMatchingObjects);


		//* guardar state
		setResponseQuestionGameOne(shuffleNewResponse);
		setNumberQuestion(numberQuestion + 1);
		setSaveResponsesGameOne(saveGame);
	};

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema3.actOne.initScene, 5);
						pointsWin = 0
						getRandomQuestionGame()
						setNumberQuestion(0)
						setSaveResponsesGameOne([])
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Evaluación: Quesera" />
					<DialogBarNew
						dialog={`¡Excelente! hemos logrado ver la manera adecuada de verificar la quesera y sus pasos. ¡Es momento de poner a prueba lo aprendido!`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 1: Ejecución de panera y quesera"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_1.sub1_act5_a02T3)
							ObserverEmitter.emit(EVENTS.characterAnimations.saludo);
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}


			{uiToShow === steps.dialogTwo && (
				<>
					<HeaderRedPresentation name="Evaluación: Quesera" />
					<DialogBarNew
						dialog={`¡Muy bien! Es hora de aplicar lo aprendido, relaciona las columnas que contienen los pasos con sus respectivas características.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.gameQuestion);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.gameQuestion && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<BarStatusActivies
						activities={tasksList}
					/>
					<RandomQuestion
						textStyleContainerQuestion={"text-[16px]"}
						action={verificationResponse}
						numberQuestion={numberQuestion}
						arrayQuestion={questionGameOne}
						anserwerQuestion={responseQuestionGameOne}
					/>
				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={pointsWin}
						dialogModal="¡Buen trabajo! El orden para acomodar la quesera es de suma importancia para evitar derrames y accidentes."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 5,
									pointsWin: pointsWin,
									subtema: tasksId.tema3.activities.subtema1
								})
							);
							navigator("/home3/tema3/subtema1/activityresult");
						}}
					/>
				</>
			)}

			{uiToShow === steps.fail && (
				<>
					<ValidationResultModal
						title="Respuesta incorrecta."
						// numberPoints={pointsWin}
						dialogModal="¡Ánimo! Recuerda que cada paso es importante para que la quesera funcione de manera adecuada."
						buttonTxt="Continuar"
						isCorrect={false}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 5,
									pointsWin: pointsWin,
									subtema: tasksId.tema3.activities.subtema1
								})
							);
							navigator("/home3/tema3/subtema1/activityresult");
						}}
					/>
				</>
			)}
		</>
	)
}
